import { createImageUrl } from '@nrk/serum-imagecrop-utils'

export const supportedWidths = [320, 450, 650, 768, 900, 1280, 1600, 1920, 2400]

export function createSrcSet ({ imageId, ratio, supportedWidths, quality = 0.7 }) {
  return supportedWidths
    .map(width => {
      const imageUrl = createImageUrl({ id: imageId, width, ratio, quality })
      return `${imageUrl} ${width}w`
    })
    .join(', ')
}

export function getQualityFromString (qualityString) {
  const qualities = [
    {
      string: 'very-high',
      quality: 0.8
    },
    {
      string: 'high',
      quality: 0.6
    },
    {
      string: 'medium',
      quality: 0.3
    },
    {
      string: 'low',
      quality: 0.2
    }
  ]

  const q = qualities.filter(quality => quality.string === qualityString)[0]
  return q.quality
}



// WEBPACK FOOTER //
// ./src/lib/image.js